/* eslint-disable indent */
import React from 'react'
import { useSelector } from 'react-redux'
import { Card, Form, Row, Col } from 'react-bootstrap'
import {
  agreeaArray,
  skillArrayB,
  specArray,
  skillArr,
  taidot,
  translations,
} from '../services/arrays'
import { getTranslation } from '../services/translations'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUser,
  faDiceThree,
  faBoltLightning,
  faGear,
  faWind,
} from '@fortawesome/free-solid-svg-icons'
import { isOverMonthOld, calculateActualAge } from '../services/helpfunctions'
import { getU21Badge } from '../services/u21utils'
import PlayerCardHeader from './PlayerCardHeader'

const Skills = ({
  player,
  playerSkills,
  calculateSkillChange,
  trainingPlan,
  nation,
  ownerNation,
}) => {
  const user = useSelector(state => state.user)
  const lang = (user && user.language) || 'fi'
  const t = key => getTranslation(lang, key)
  const skillArray = [...skillArrayB].reverse()
  const language = lang === 'en' ? 1 : 0
  const safePlayerSkills = {
    staminaSkill: 0,
    keeperSkill: 0,
    defenderSkill: 0,
    playmakerSkill: 0,
    wingerSkill: 0,
    passingSkill: 0,
    scorerSkill: 0,
    setPiecesSkill: 0,
    ...(playerSkills || {}),
  }
  const safeTrainingData =
    player && player.trainingData && typeof player.trainingData === 'object'
      ? player.trainingData
      : {}
  const safeHTMS =
    player && Array.isArray(player.HTMS) && player.HTMS.length >= 2
      ? player.HTMS
      : [0, 0]

  const actualAge = calculateActualAge(player)
  const playerIsOverMonthOld = isOverMonthOld(player.dateUpdated)
  const u21Badge =
    actualAge.years <= 21 ? getU21Badge(actualAge.years, actualAge.days) : null

  return (
    <>
      <Row className="d-flex align-items-stretch">
        <Col md={8} className="d-flex">
          <Card
            className="flex-fill"
            style={{
              backgroundColor: '#2C2F33',
              color: '#FFFFFF',
              borderColor: '#1E2124',
            }}
          >
            <PlayerCardHeader
              player={player}
              nation={nation}
              ownerNation={ownerNation}
              actualAge={actualAge}
              u21Badge={u21Badge}
              t={t}
            />
            <Card.Body>
              <Row>
                <Col md={8}>
                  <Card.Text>
                    {t('character')}:{' '}
                    {agreeaArray[Number(player.agreeability) + 1]}{' '}
                    <span
                      style={{
                        color:
                          [
                            '#e74c3c',
                            '#e67e22',
                            '#f1c40f',
                            '#8ecc39',
                            '#2ecc71',
                            '#39ff14',
                          ][Number(player.agreeability)] || '#fff',
                        fontSize: '0.75rem',
                      }}
                    >
                      ({Number(player.agreeability)})
                    </span>
                  </Card.Text>
                  <Card.Text>
                    {t('experience')}: {skillArray[Number(player.experience)]} (
                    {Number(player.experience)})<br />
                    {t('leadership')}: {skillArray[Number(player.leadership)]} (
                    {Number(player.leadership)})<br />
                    {t('loyalty')}: {skillArray[Number(player.loyalty)]} (
                    {Number(player.loyalty)})
                  </Card.Text>
                  <Card.Text>
                    TSI: {player.tsi} <br />
                    {t('salary')}: {player.salary / 10} € <br />
                    {t('specialty')}:{' '}
                    {(() => {
                      const specIcons = {
                        1: faGear,
                        2: faWind,
                        3: faBoltLightning,
                        4: faDiceThree,
                        5: faUser,
                      }
                      const specNum = Number(player.specialty)
                      return specIcons[specNum] ? (
                        <>
                          <FontAwesomeIcon
                            icon={specIcons[specNum]}
                            style={{ marginRight: '4px' }}
                          />
                          {specArray[specNum]}
                        </>
                      ) : (
                        specArray[specNum]
                      )
                    })()}{' '}
                    <br />
                    {t('form')}: {player.playerForm} <br />
                    {t('stamina')}:{' '}
                    {Number(safePlayerSkills.staminaSkill).toFixed(2)} <br />
                    HTMS: {safeHTMS[0]}/{safeHTMS[1]}
                  </Card.Text>
                </Col>
                <Col md={4}>
                  <Form>
                    {skillArr.map(skill => (
                      <Form.Group
                        as={Row}
                        controlId={`form${skill}`}
                        key={skill}
                      >
                        <Form.Label column sm="6">
                          {translations[skill]
                            ? translations[skill][language]
                            : skill.replace('Skill', '')}
                          :
                        </Form.Label>
                        <Col sm="6">
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              backgroundColor: '#23272A',
                              color: '#FFFFFF',
                              padding: '5px',
                              borderRadius: '4px',
                              border: '1px solid #1E2124',
                              fontSize: '0.875rem',
                            }}
                          >
                            {/* Esitetään taito kolmen desimaalin tarkkuudella */}
                            <span>
                              {Number(safePlayerSkills[skill]).toFixed(3)}
                            </span>

                            {player.oldPlayerSkills &&
                              player.oldPlayerSkills[skill] !== undefined && (
                                <span
                                  style={{
                                    color:
                                      safePlayerSkills[skill] >
                                      player.oldPlayerSkills[skill]
                                        ? 'green'
                                        : safePlayerSkills[skill] <
                                          player.oldPlayerSkills[skill]
                                        ? '#ff7575'
                                        : 'white',
                                    marginLeft: '10px',
                                    fontWeight: 'bold', // Muutoksen boldataus
                                  }}
                                >
                                  {/* Lasketaan ja näytetään taitomuutos */}
                                  {calculateSkillChange(
                                    Number(safePlayerSkills[skill]).toFixed(3), // Kolmen desimaalin tarkkuus
                                    player.oldPlayerSkills[skill].toFixed(3) // Kolmen desimaalin tarkkuus
                                  )}
                                </span>
                              )}
                          </div>
                        </Col>
                      </Form.Group>
                    ))}
                  </Form>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4} className="d-flex">
          <Card
            className="flex-fill"
            style={{
              backgroundColor: '#2C2F33',
              color: '#FFFFFF',
              borderColor: '#1E2124',
            }}
          >
            <Card.Header
              style={{ backgroundColor: '#23272A', color: '#FFFFFF' }}
            >
              {t('trainingInfo')}
            </Card.Header>
            <Card.Body>
              {!playerIsOverMonthOld ? (
                Object.entries(safeTrainingData).map(([key, value], index) => {
                  // Suodatetaan pois "minutes" ja "effency" kentät
                  if (key === 'minutes' || key === 'effency') {
                    return null // Ei näytetä näitä kenttiä
                  }

                  // Käsitellään "mode" kenttä erityisesti, jolloin arvo on taidot[mode - 1]
                  const displayValue =
                    key === 'mode' ? taidot[value - 1] : value

                  return (
                    <Card.Text
                      key={index}
                      style={{ fontSize: '0.875rem', marginBottom: '5px' }}
                    >
                      {/* Näytetään kentän nimi ja arvo */}
                      {key.replace(/([A-Z])/g, ' $1').trim()}: {displayValue}
                    </Card.Text>
                  )
                })
              ) : (
                <Card.Text style={{ fontSize: '0.875rem', color: '#888' }}>
                  -
                </Card.Text>
              )}
              {trainingPlan &&
              trainingPlan.finalLevels &&
              trainingPlan.skillWeeks ? (
                <div className="mt-4" style={{ fontSize: '0.875rem' }}>
                  <h6 className="text-sm">{t('trainingPlan')}</h6>

                  {/* Otsikot: Taito, Viikot, Taitotaso */}
                  <Row className="text-sm">
                    <Col>
                      <strong>{t('skill')}</strong>
                    </Col>
                    <Col>
                      <strong>{t('weeks')}</strong>
                    </Col>
                    <Col>
                      <strong>{t('skillLevel')}</strong>
                    </Col>
                  </Row>

                  {/* Listataan taidot, viikot ja taitotasot */}
                  {trainingPlan.finalLevels.map((level, index) => (
                    <Row key={index} className="text-sm">
                      <Col>{level.skill.replace('Skill', '')}</Col>
                      <Col>{trainingPlan.skillWeeks[index]?.weeks ?? '-'}</Col>
                      <Col>
                        {level.finalLevel !== null
                          ? level.finalLevel.toFixed(3)
                          : '-'}
                      </Col>
                    </Row>
                  ))}

                  {/* Lopuksi ikä ja totalWeeks */}
                  <div className="mt-3 text-sm">
                    <p>
                      {t('age')}: {trainingPlan.finalAge[0]}.
                      {trainingPlan.finalAge[1]} <br />
                      {t('weeks')}: {trainingPlan.totalWeeks}
                    </p>
                  </div>
                </div>
              ) : (
                <></>
              )}

              {/* Scout Comments - read only */}
              {player.scoutComments && (
                <>
                  <hr style={{ borderColor: '#444' }} />
                  <div style={{ fontSize: '0.875rem' }}>
                    <strong>
                      {t('scoutComments') || 'Scoutin kommentit'}:
                    </strong>
                    <p
                      style={{ whiteSpace: 'pre-wrap', margin: '0.5rem 0 0 0' }}
                    >
                      {player.scoutComments}
                    </p>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default Skills
